import React from 'react';
import './styles.scss';

const NumberCircle = ({ data }) => {
  const { number } = data; 

  return (
    <div className="number-circle">
      {number}
    </div>
  );
};

export default NumberCircle;
